import { render } from "./AddAudioFile.vue?vue&type=template&id=7e8f80a4&scoped=true"
import script from "./AddAudioFile.vue?vue&type=script&lang=js"
export * from "./AddAudioFile.vue?vue&type=script&lang=js"

import "./AddAudioFile.vue?vue&type=style&index=0&id=7e8f80a4&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-7e8f80a4"

export default script